<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-4 sm:px-8 flex flex-col h-full w-full py-4 sm:py-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/employment" class="opacity-50 hover:opacity-100">Employment</router-link>
                        <span class="mx-2">/</span>
                        <span>Unemployed Graduates</span>
                    </div>
                    <div class="font-bold">Unemployed Graduates</div>
                </div>

                <!-- Unemployed Graduates Dashboard Start -->
                <div v-if="showDashboard" class="flex flex-col mt-8">
                    <div class="grid grid-col-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-8">
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">Total</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">
                                        {{ totalAlumni }}
                                    </h1>
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('ATHS')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">ATS</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">
                                        {{ atsTotalAlumni }}
                                    </h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-8" src="../../assets/images/dashboard/alumni/ATS.png" alt="ATS" />
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('ADPOLY')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">ADPOLY</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">
                                        {{ adpolyTotalAlumni }}
                                    </h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-12" src="../../assets/images/dashboard/alumni/ADPOLY.png"
                                        alt="ADPOLY" />
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('FCHS')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">FCHS</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">
                                        {{ fchsTotalAlumni }}
                                    </h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-14" src="../../assets/images/dashboard/alumni/FCHS.png" alt="FCHS" />
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('ADVETI')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">ADVETI</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">
                                        {{ advetiTotalAlumni }}
                                    </h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-16" src="../../assets/images/dashboard/alumni/ADVETI.png"
                                        alt="ADVETI" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-8 mt-8">
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">Alumni / Entity</h1>
                            <div v-if="isDashboardLoading" class="wd-380 ht-242-7 flex items-center">
                                <div class="">
                                    <div class="ml-8 wd-216 ht-216 rounded-full bg-gray-200 animate-pulse"></div>
                                </div>
                            </div>
                            <apexchart v-else type="pie" width="380" :options="chartOptions1" :series="series1">
                            </apexchart>
                        </div>
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">Portal Registration Status</h1>
                            <div v-if="isDashboardLoading" class="wd-380 ht-242-7 flex items-center">
                                <div class="">
                                    <div class="ml-8 wd-216 ht-216 rounded-full bg-gray-200 animate-pulse"></div>
                                </div>
                            </div>
                            <apexchart v-else type="pie" width="433" :options="chartOptions7" :series="series7">
                            </apexchart>
                        </div>
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">Employment Status</h1>
                            <div v-if="isDashboardLoading" class="wd-380 ht-242-7 flex items-center">
                                <div class="">
                                    <div class="ml-8 wd-216 ht-216 rounded-full bg-gray-200 animate-pulse"></div>
                                </div>
                            </div>
                            <apexchart v-else type="pie" width="433" :options="chartOptions2" :series="series2">
                            </apexchart>
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-8 mt-8">
                        <div v-if="isShowChart('ATHS')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">ATS BOYS</h1>
                            <div v-if="isDashboardLoading" class="ht-350 bg-gray-200 animate-pulse"></div>
                            <apexchart v-else type="bar" height="350" :options="chartOptions3" :series="series3">
                            </apexchart>
                        </div>
                        <div v-if="isShowChart('ATHS')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">ATS GIRLS</h1>
                            <div v-if="isDashboardLoading" class="ht-350 bg-gray-200 animate-pulse"></div>
                            <apexchart v-else type="bar" height="350" :options="chartOptions10" :series="series10">
                            </apexchart>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 2xl:grid-cols-2 gap-8 mt-8">
                        <div v-if="isShowChart('ADPOLY')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">ADPOLY</h1>
                            <div v-if="isDashboardLoading" class="ht-350 bg-gray-200 animate-pulse"></div>
                            <apexchart v-else type="bar" height="350" :options="chartOptions4" :series="series4">
                            </apexchart>
                        </div>
                        <div v-if="isShowChart('FCHS')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">FCHS</h1>
                            <div v-if="isDashboardLoading" class="ht-350 bg-gray-200 animate-pulse"></div>
                            <apexchart v-else type="bar" height="350" :options="chartOptions5" :series="series5">
                            </apexchart>
                        </div>
                        <div v-if="isShowChart('ADVETI')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">ADVETI</h1>
                            <div v-if="isDashboardLoading" class="ht-350 bg-gray-200 animate-pulse"></div>
                            <apexchart v-else type="bar" height="350" :options="chartOptions6" :series="series6">
                            </apexchart>
                        </div>
                    </div>

                    <div class="grid grid-cols-1 gap-8 mt-8">
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">ACADEMIC YEAR</h1>
                            <div v-if="isDashboardLoading" class="ht-350 bg-gray-200 animate-pulse"></div>
                            <apexchart v-else type="bar" height="350" :options="chartOptions8" :series="series8">
                            </apexchart>
                        </div>
                    </div>

                    <div v-if="isShowChart('ATHS')" class="grid grid-cols-1 gap-8 mt-8">
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">ATS EMSAT</h1>
                            <div v-if="isDashboardLoading" class="ht-430 bg-gray-200 animate-pulse"></div>
                            <apexchart v-else type="bar" height="430" :options="chartOptions9" :series="series9">
                            </apexchart>
                        </div>
                    </div>

                    <div v-if="isShowChart('ATHS')" class="grid grid-cols-1 gap-8 mt-8">
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">UNIVERSITY COUNTRY</h1>
                            <div v-if="isDashboardLoading" class="ht-60-vh bg-gray-200 animate-pulse"></div>
                            <div v-else class="flex flex-row flex-wrap">
                                <div :class="getCountryClass" class="mt-8 lg:mt-0">
                                    <MapChart :key="universityCountryChartUniqueKey"
                                        :id="universityCountryChartUniqueKey" :countryData="countryData"
                                        highColor="#09306b" lowColor="#b6d3e9" countryStrokeColor="#909090"
                                        defaultCountryFillColor="#dadada" :currencyAdd="false" LangUser="en"
                                        :showEmptyValue="false" />
                                </div>
                                <div :class="getCountryListClass"
                                    class="flex flex-col justify-center text-map-color pl-0 lg:pl-8 mt-8 lg:mt-0">
                                    <div v-for="(item, index) in universityCountryResultsList" :key="index"
                                        class="mb-1">
                                        <span class="mr-2 font-bold">{{ item.university_country }}:</span><span>{{
                                            item.count }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Unemployed Graduates Dashboard End -->

                <div class="mt-4 flex justify-end items-center">
                    <div @click.stop="openSendJobOpporunityEmailModal" :title="getSendJobOpportunityBtnTitleText"
                        v-if="hasPermission('send-job-opportunity-email')"
                        class="w-44 hidden items-center justify-center hover:bg-white bg-blue-600 border-blue-600 hover:border-blue-600 border px-4 py-2 rounded-lg cursor-pointer hover:text-blue-600 text-white mr-4">
                        <font-awesome-icon :icon="['fas', 'paper-plane']" />
                        <span class="text-xs ml-2">{{ getSendJobOpportunityBtnText }}</span>
                    </div>
                    <div>
                        <div v-if="isExportExcel"
                            class="w-44 flex items-center justify-center hover:bg-white bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg hover:text-ternary text-white">
                            <base-spinner-with-text class-list="w-4 h-4" text=""
                                text-class-list="text-white"></base-spinner-with-text>
                            <span class="text-xs">Exporting Excel</span>
                        </div>
                        <div v-else @click="generateReport"
                            class="w-44 flex items-center justify-center hover:bg-white bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg cursor-pointer hover:text-ternary text-white">
                            <font-awesome-icon :icon="['fas', 'file-excel']" />
                            <span class="text-xs ml-2">Export Excel</span>
                        </div>
                    </div>
                </div>

                <section class="mt-4 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-end flex-wrap">
                        <!-- <h1 class="text-base md:text-lg font-semibold text-ternary">Students List</h1> -->
                        <div class="flex justify-start items-center flex-wrap w-full">
                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Entity:</div>
                                <select v-model="filterByEntity" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item.entity" v-for="(item, index) in filteredEntities" :key="index">
                                        {{ getEntityName(item.entity) }}</option>
                                </select>
                            </div>

                            <div class="w-full sm:w-40 mr-0 sm:mr-8 mb-4 border rounded-lg px-4 py-2 h-auto flex justify-between items-center relative cursor-pointer"
                                :class="activeDropDown == 'campus' ? 'z-30' : ''">
                                <div class="flex flex-grow justify-between items-center"
                                    @click.stop="showCampusDropDown = !showCampusDropDown">
                                    <div class="text-sm mr-2 sm:mb-0 flex-shrink-0 flex-grow">
                                        Campus:
                                    </div>
                                    <icon-chevron-down class="h-4 w-4"></icon-chevron-down>
                                </div>
                                <div v-show="showCampusDropDown"
                                    class="flex flex-col max-h-80 overflow-y-auto shadow-lg rounded-lg px-2 pt-2 absolute w-full bg-white border left-0 top-10">
                                    <div v-for="(item, index) in filteredCampuses" :key="index"
                                        class="flex items-center mb-2 cursor-pointer">
                                        <input type="checkbox" :value="item.campus_code" :id="`campus-${index}`"
                                            v-model="filterByCampuses" class="mr-2" />
                                        <label :for="`campus-${index}`" class="text-sm">{{
                                            item.campus_code
                                            }}</label>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Local or Non Local:</div>
                                <select v-model="filterByLocalOrNonLocal" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="Local">Local</option>
                                    <option value="Non Local">Non Local</option>
                                </select>
                            </div>

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Gender:</div>
                                <select v-model="filterByGender" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="M">Male</option>
                                    <option value="F">Female</option>
                                </select>
                            </div>

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Registration Status:</div>
                                <select v-model="filterByRegistration" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="Yes">Registered</option>
                                    <option value="No">Not Registered</option>
                                </select>
                            </div>

                            <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 py-2 h-auto flex items-center relative cursor-pointer"
                                :class="activeDropDown == 'academic_year' ? 'z-30' : ''">
                                <div class="flex flex-grow justify-between items-center" @click.stop="
                                    showAcademicYearDropDown = !showAcademicYearDropDown
                                    ">
                                    <div class="text-sm mr-2 sm:mb-0 flex-shrink-0">
                                        Academic Year:
                                    </div>
                                    <icon-chevron-down class="h-4 w-4"></icon-chevron-down>
                                </div>
                                <div v-show="showAcademicYearDropDown"
                                    class="flex flex-col max-h-80 overflow-y-auto shadow-lg rounded-lg px-2 pt-2 absolute w-full bg-white border left-0 top-10">
                                    <div v-for="(item, index) in academicYearsList" :key="index"
                                        class="flex items-center mb-2">
                                        <input type="checkbox" :value="item" :id="`academic-year-${index}`"
                                            v-model="filterByAcademicYears" class="mr-2" />
                                        <label :for="`academic-year-${index}`" class="text-sm">{{
                                            item
                                            }}</label>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">{{ getSpecializationTitle }}:</div>
                                <select v-model="filterBySpecialization" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item" v-for="(item, index) in specializationsList" :key="index">{{
                                        item }}</option>
                                </select>
                            </div>

                            <!-- <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Sponsor:</div>
                                <select v-model="filterBySponsor" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item" v-for="(item, index) in sponsorsList" :key="index">{{ item }}
                                    </option>
                                </select>
                            </div> -->

                            <!-- <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Skill Hub:</div>
                                <select v-model="filterBySkillHub" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div> -->

                            <!-- <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">EmSat Subject:</div>
                                <select v-model="filterByEmSatSubject" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="em_sat_math">Mathematics</option>
                                    <option value="em_sat_phy">Physics</option>
                                    <option value="em_sat_eng">English</option>
                                    <option value="em_sat_arab">Arabic</option>
                                    <option value="em_sat_chem">Chemistry</option>
                                    <option value="em_sat_bio">Biology</option>
                                    <option value="em_sat_cse">Computer Science</option>
                                </select>
                            </div> -->

                            <!-- <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">EmSat Value:</div>
                                <select v-model="filterByEmSatValue" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item.key" v-for="(item, index) in emSatValueOptions" :key="index">{{
                                        item.value }}</option>
                                </select>
                            </div> -->

                            <!-- <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Place of Study:</div>
                                <select v-model="filterByStudyStatus" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="Yes">United Arab Emirates</option>
                                    <option value="No">Abroad</option>
                                </select>
                            </div> -->

                            <!-- <div v-if="isATS" class="flex justify-start items-center flex-wrap">
                                <div
                                    class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                    <div class="text-sm mr-2">Stream:</div>
                                    <select v-model="filterByStream" class="outline-none text-sm flex-grow">
                                        <option value="">All</option>
                                        <option value="Advanced">Advanced</option>
                                        <option value="ASP">ASP</option>
                                        <option value="General">General</option>
                                    </select>
                                </div>

                                <div
                                    class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                    <div class="text-sm mr-2">Country:</div>
                                    <select v-model="filterByUniversityCountry" class="outline-none text-sm flex-grow">
                                        <option value="">All</option>
                                        <option :value="item" v-for="(item, index) in universityCountryList"
                                            :key="index">{{ item }}</option>
                                    </select>
                                </div>

                                <div
                                    class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                    <div class="text-sm mr-2">University:</div>
                                    <select v-model="filterByUniversityName" class="outline-none text-sm flex-grow">
                                        <option value="">All</option>
                                        <option :value="item" v-for="(item, index) in universityNamesList" :key="index">
                                            {{ item }}</option>
                                    </select>
                                </div>

                                <div class="w-full sm:w-80 mr-0 sm:mr-8 mb-4 border rounded-lg px-4 py-2 h-auto flex items-center relative cursor-pointer"
                                    :class="activeDropDown == 'college' ? 'z-30' : ''">
                                    <div class="flex flex-grow justify-between items-center"
                                        @click.stop="showCollegeDropDown = !showCollegeDropDown">
                                        <div class="text-sm mr-2 sm:mb-0 flex-shrink-0">
                                            College:
                                        </div>
                                        <icon-chevron-down class="h-4 w-4"></icon-chevron-down>
                                    </div>
                                    <div v-show="showCollegeDropDown"
                                        class="flex flex-col max-h-80 overflow-y-auto shadow-lg rounded-lg px-2 pt-2 absolute w-full bg-white border left-0 top-10">
                                        <div v-for="(item, index) in collegesList" :key="index"
                                            class="flex items-center mb-2">
                                            <input type="checkbox" :value="item" :id="`college-${index}`"
                                                v-model="filterByColleges" class="mr-2" />
                                            <label :for="`college-${index}`" class="text-sm">{{
                                                item
                                                }}</label>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                    <div class="text-sm mr-2">Program of entry:</div>
                                    <select v-model="filterByProgramOfEntry" class="outline-none text-sm flex-grow">
                                        <option value="">All</option>
                                        <option value="Foundation">Foundation</option>
                                        <option value="Direct entry">Direct entry</option>
                                    </select>
                                </div>
                            </div> -->
                            <!-- <div v-if="!isATS && filterByEntity != ''"
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Degree:</div>
                                <select v-model="filterByDegree" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="Diploma">Diploma</option>
                                    <option value="Higher Diploma">Higher Diploma</option>
                                    <option value="Bachelor">Bachelor</option>
                                </select>
                            </div> -->

                            <div class="w-full sm:w-auto mb-4">
                                <search @on-search="onSearch" class-list="px-4 h-8"></search>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-start">
                        <div @click.stop="clearAllFilter()"
                            class="px-3 py-1 text-sm border border-red-500 bg-red-500 hover:bg-white text-white hover:text-red-500 rounded-lg cursor-pointer">
                            Clear All Filter
                        </div>
                    </div>

                    <div class="flex flex-col" v-if="$apollo.queries.students.loading">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <div class="min-w-full text-left text-sm font-light">
                                        <div class="border-b font-medium dark:border-neutral-500">
                                            <div class="flex">
                                                <div class="px-6 py-2 text-gray-400 w-12 lg:w-16">
                                                    #
                                                </div>
                                                <div class="flex-grow px-6 py-2 text-gray-400">
                                                    <div class="w-32 md:w-auto">Name</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Entity</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">
                                                        {{ getSpecializationTitle }}
                                                    </div>
                                                </div>
                                                <!-- <div v-if="isATS" class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">University</div>
                                                </div>
                                                <div v-else class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Employer</div>
                                                </div>
                                                <div v-if="!isATS" class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Designation</div>
                                                </div> -->
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Academic Year</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Graduation Year</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Is Registered</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400 w-24 lg:w-40">
                                                    Actions
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <student-tile-shimmer v-for="(sts, index) in first"
                                                :key="index"></student-tile-shimmer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="noItems" class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No students found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">
                                                    #
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Name
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Entity
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Campus
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    {{ getSpecializationTitle }}
                                                </th>
                                                <!-- <th v-if="isATS" scope="col" class="px-6 py-2 text-gray-400">
                                                    University
                                                </th>
                                                <th v-else scope="col" class="px-6 py-2 text-gray-400">
                                                    Employer
                                                </th>
                                                <th v-if="!isATS" scope="col" class="px-6 py-2 text-gray-400">
                                                    Designation
                                                </th> -->
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Academic Year
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Graduation Year
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Is Registered
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(student, index) in filteredStudents" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">
                                                    {{ paginatorInfo.firstItem + index }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div class="flex items-center">
                                                        <div class="flex-shrink-0 mr-3">
                                                            <img @click.stop="
                                                                openPreviewImgModal(
                                                                    student.profile_picture_url,
                                                                    student.student_id,
                                                                    student.entity
                                                                )
                                                                "
                                                                class="h-12 w-12 rounded-lg object-cover cursor-pointer"
                                                                :src="getProfilePicture(
                                                                    student.profile_picture_url,
                                                                    student.student_id,
                                                                    student.entity
                                                                )
                                                                    " alt="" />
                                                        </div>
                                                        <div class="flex-grow flex flex-col">
                                                            <h1 class="text-sm font-semibold flex items-center">
                                                                <span @click.stop="
                                                                    viewStudentProfile(student.student_id)
                                                                    "
                                                                    class="text-heading hover:text-blue-600 hover:underline cursor-pointer">{{
                                                                        student.name_en }}</span>
                                                            </h1>
                                                            <p class="text-xs text-gray-400">
                                                                {{ student.name_ar }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    {{ getEntityName(student.entity) }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    {{ student.campus_code }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    {{
                                                        getSpecialization(
                                                            student.entity,
                                                            student.study_program,
                                                            student.program_name,
                                                            student.program_code,
                                                            student.cluster_e
                                                        )
                                                    }}
                                                </td>
                                                <!-- <td v-if="isATS" class="whitespace-nowrap px-6 py-2">
                                                    {{ student.university_name }}
                                                </td>
                                                <td v-else class="whitespace-nowrap px-6 py-2">
                                                    {{
                                                        getEmployerName(
                                                            student.is_employed,
                                                            student.employmentInformations
                                                        )
                                                    }}
                                                </td>
                                                <td v-if="!isATS" class="whitespace-nowrap px-6 py-2">
                                                    {{ getDesignation(student.employmentInformations) }}
                                                </td> -->
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    {{
                                                        getAcademicYear(student.academic_year, student.ay)
                                                    }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    {{
                                                        getGraduationYear(
                                                            student.grad_year,
                                                            student.academic_year_graduation
                                                        )
                                                    }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    {{ isRegistered(student.user_id) }}
                                                </td>
                                                <td class="px-6 py-2">
                                                    <div class="flex">
                                                        <div v-if="hasPermission('students-show')" @click.stop="
                                                            viewStudentProfile(student.student_id)
                                                            "
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-eye
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                        </div>
                                                        <!-- <div v-if="hasPermission('students-show')"
                                                            @click.stop="generatePdf(student.student_id)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-printer
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-printer>
                                                        </div> -->
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="previewImageModal" title="" height="50vh" @close="closePreviewImageModal">
                            <img class="h-full w-full object-contain" :src="previewImg" />
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="showStudentProfileFullModal" title="Student Profile"
                            @close="closeFullModal">
                            <student-profile :student-id="studentId"></student-profile>
                        </base-full-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="showSendJobOpporunityEmailModal"
                            :title="getSendJobOpportunityBtnTitleText" @close="closeSendJobOpporunityEmailModal">
                            <send-job-opportunity-email :filters="getFilters"
                                :selected-students="selectedStudents"></send-job-opportunity-email>
                        </base-full-modal>
                    </transition>

                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isExportExcel">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>
<script>
import IconEye from "../../components/icons/IconEye.vue";
// import IconPrinter from "../../components/icons/IconPrinter.vue";
import gql from "graphql-tag";
import Pagination from "../../components/shared/pagination.vue";
import StudentTileShimmer from "../../components/students/StudentTileShimmer.vue";
import Search from "../../components/shared/search.vue";
import xlsx from "xlsx/dist/xlsx.full.min.js";
import StudentProfile from "../student-profile/index.vue";
import MapChart from "vue-chart-map";
import IconChevronDown from "../../components/icons/IconChevronDown.vue";
import SendJobOpportunityEmail from "./send-job-opportunity-email.vue";
export default {
    name: "unemployed-graduates-index",
    components: {
        IconEye,
        // IconPrinter,
        Pagination,
        StudentTileShimmer,
        Search,
        StudentProfile,
        MapChart,
        IconChevronDown,
        SendJobOpportunityEmail,
    },
    data() {
        return {
            students: [],
            first: 10,
            page: 1,
            editStudentModal: false,
            openviewStudentModal: false,
            modalTitle: "",
            studentId: null,
            searchText: "",
            filterByEntity: "",
            filterByAcademicYears: [],
            filterByCampuses: [],
            filterByColleges: [],
            filterByStream: "",
            filterByUniversityCountry: "",
            filterByProgramOfEntry: "",
            filterByDegree: "",
            filterByEmSatSubject: "",
            filterByEmSatValue: "",
            filterByUniversityName: "",
            filterByStudyStatus: "",
            filterByMajor: "",
            filterBySpecialization: "",
            filterBySponsor: "",
            filterBySkillHub: "",
            filterByStatus: "IG",
            filterByLocalOrNonLocal: "",
            filterByGender: "",
            filterByRegistration: "",
            filterByEmploymentStatus: "0",
            filterByEmployer: "",
            filterByDesignation: "",
            filterByEmployerLocation: "",
            filterBySector: "",
            previewImageModal: false,
            previewImg: "",
            isGenerateReport: false,
            showFullModal: false,
            entities: [],
            showStudentProfileFullModal: false,
            isDashboardLoading: false,
            totalAlumni: 0,
            atsTotalAlumni: 0,
            adpolyTotalAlumni: 0,
            fchsTotalAlumni: 0,
            advetiTotalAlumni: 0,
            registered: 0,
            notRegistered: 0,
            employed: 0,
            unEmployed: 0,
            notUpdated: 0,
            atsCampusCodeResults: [],
            atsGirlsCampusCodeResults: [],
            adpolyCampusCodeResults: [],
            fchsCampusCodeResults: [],
            advetiCampusCodeResults: [],
            academicYearsList: [],
            employerList: [],
            designationList: [],
            employerLocationList: [],
            specializationsList: [],
            sponsorsList: [],
            universityCountryList: [],
            universityNamesList: [],
            collegesList: [],
            majorsList: [],
            campusList: [],
            atsAcademicYearResults: [],
            fchsAcademicYearResults: [],
            adpolyAcademicYearResults: [],
            advetiAcademicYearResults: [],
            academicYears: [],
            universityCountryResultsList: [],
            universityCountryResults: {},
            universityCountryCodeList: [],
            universityCountryChartUniqueKey: new Date().getTime(),
            emSatAbove1000Data: [],
            emSatBelow1000Data: [],
            atsEmployed: 0,
            atsUnEmployed: 0,
            adpolyEmployed: 0,
            adpolyUnEmployed: 0,
            fchsEmployed: 0,
            fchsUnEmployed: 0,
            advetiEmployed: 0,
            advetiUnEmployed: 0,
            isExportExcel: false,
            isApiCallRecurisive: false,
            generatedReport: [],
            showAcademicYearDropDown: false,
            showCollegeDropDown: false,
            activeDropDown: "",
            showCampusDropDown: false,
            showDashboard: false,
            showSendJobOpporunityEmailModal: false,
        };
    },
    created() {
        this.getAcademicYears();
        this.getSpecializations();
        this.getSponsorsList();
        this.getCampusList();
        this.getEmployerList();
        this.getDesignationList();
        this.getEmployerLocationList();
        this.getAlumniDashboard();
    },
    watch: {
        showAcademicYearDropDown(newVal) {
            if (newVal) {
                this.activeDropDown = "academic_year";
                this.collapseDropDown("academic_year");
            }
        },
        showCollegeDropDown(newVal) {
            if (newVal) {
                this.activeDropDown = "college";
                this.collapseDropDown("college");
            }
        },
        universityCountryResults(newVal) {
            this.universityCountryChartUniqueKey = new Date().getTime();

            let $this = this;

            setTimeout(() => {
                $this.universityCountryCodeList.forEach((value) => {
                    var element2 = document.getElementById(value);
                    if (element2) {
                        element2.style.fill = "#dadada";
                        element2.style.setProperty("fill", "#dadada", "important");
                    }
                });

                var opacity = 1;
                var lap = 0;
                var opacityDiff = 0;

                let i = 0;
                for (const key in newVal) {
                    if (newVal[key] !== undefined && newVal[key] !== null) {
                        var element1 = document.getElementById(key);
                        if (element1) {
                            if (i == 0) {
                                opacity = 1;
                            } else {
                                opacity = (100 - lap) / 100;
                            }
                            element1.style.fill = `rgba(9, 48, 107, ${opacity})`;
                            element1.style.setProperty(
                                "fill",
                                `rgba(9, 48, 107, ${opacity})`,
                                "important"
                            );
                            i++;
                            opacityDiff = 100 / 11;
                            lap = lap + opacityDiff;
                        }
                    }
                }
            }, 300);
        },
        searchText() {
            this.page = 1;
        },
        filterByEntity(newVal) {
            this.clearAllFilter("filterByEntity");
            this.page = 1;
            this.getAcademicYears();
            this.getEmployerList();
            this.getDesignationList();
            this.getEmployerLocationList();
            this.getSpecializations();
            this.getSponsorsList();
            if (newVal == "ATHS" || newVal == "ATS") {
                this.getUniversityNames();
                this.getCollegesList();
                this.getMajors();
                this.getUniversityCountries();
            }
            this.getAlumniDashboard();
        },
        filterByAcademicYears() {
            this.page = 1;
            this.filterBySpecialization = "";
            this.getSpecializations();
            this.filterByEmSatSubject = "";
            this.filterByEmSatValue = "";
            this.getAlumniDashboard();
        },
        filterBySpecialization() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterBySponsor() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByStream() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByUniversityCountry() {
            this.filterByUniversityName = "";
            this.getUniversityNames();
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByProgramOfEntry() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByDegree() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByEmSatSubject() {
            if (this.filterByEmSatValue != "") {
                this.page = 1;
                this.getAlumniDashboard();
            }
        },
        filterByEmSatValue() {
            if (this.filterByEmSatSubject != "") {
                this.page = 1;
                this.getAlumniDashboard();
            }
        },
        filterByUniversityName() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByStudyStatus() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByMajor() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByCampuses() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByColleges() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByLocalOrNonLocal() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByGender() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByRegistration() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByEmploymentStatus() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByEmployer() {
            this.page = 1;
            this.getDesignationList();
            this.getEmployerLocationList();
            this.getAlumniDashboard();
        },
        filterByDesignation() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterByEmployerLocation() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        filterBySector() {
            this.page = 1;
            this.getAlumniDashboard();
        },
        showCampusDropDown(newVal) {
            if (newVal) {
                this.activeDropDown = "campus";
                this.collapseDropDown("campus");
            }
        },
    },
    computed: {
        selectedStudents() {
            if (this.$apollo.queries.students.loading) {
                return 0;
            } else {
                return this.paginatorInfo.total;
            }
        },
        getFilters() {
            return {
                entity: this.filterByEntity,
                campuses: this.filterByCampuses,
                local_or_non_local: this.filterByLocalOrNonLocal,
                gender: this.filterByGender,
                filter_by_registration: this.filterByRegistration,
                academic_years: this.filterByAcademicYears,
                specialization: this.filterBySpecialization,
                search: this.searchText,
            };
        },
        getSendJobOpportunityBtnTitleText() {
            if (this.$apollo.queries.students.loading) {
                return "Send job opportunity email to students";
            } else {
                return `Send job opportunity email to ${this.paginatorInfo.total} students`;
            }
        },
        getSendJobOpportunityBtnText() {
            if (this.$apollo.queries.students.loading) {
                return "Send Email";
            } else {
                return `Send Email (${this.paginatorInfo.total})`;
            }
        },
        getSpecializationTitle() {
            if (this.filterByEntity == "ATHS" || this.filterByEntity == "ATS") {
                return "Cluster";
            } else {
                return "Program";
            }
        },
        emSatValueOptions() {
            if (this.filterByEmSatSubject) {
                return [
                    {
                        key: "abv_1100",
                        value: "Above 1100",
                    },
                    {
                        key: "blw_1100",
                        value: "Below 1100",
                    },
                ];
            } else {
                return [];
            }
        },
        getCountryClass() {
            if (this.universityCountryResultsList.length > 0) {
                return "w-full lg:w-3/4";
            } else {
                return "w-full";
            }
        },
        getCountryListClass() {
            if (this.universityCountryResultsList.length > 0) {
                return "w-full lg:w-1/4";
            } else {
                return "w-full";
            }
        },
        noItems() {
            if (
                !this.$apollo.queries.students.loading &&
                this.filteredStudents.length <= 0
            ) {
                return true;
            } else {
                return false;
            }
        },
        isATS() {
            if (this.filterByEntity == "ATHS" || this.filterByEntity == "ATS") {
                return true;
            } else {
                return false;
            }
        },
        filteredCampuses() {
            if (this.filterByEntity) {
                return this.campusList.filter(
                    (campus) => campus.entity === this.filterByEntity
                );
            } else {
                return this.campusList;
            }
        },
        filteredStudents() {
            return this.students.data;
        },
        paginatorInfo() {
            return this.students.paginatorInfo;
        },
        role() {
            return this.$store.getters.role;
        },
        userEntities() {
            return this.$store.getters.entity;
        },
        filteredEntities() {
            return this.entities.data;
        },
        series1() {
            switch (this.filterByEntity) {
                case "ATHS":
                    return [this.atsTotalAlumni];
                case "ADPOLY":
                    return [this.adpolyTotalAlumni];
                case "FCHS":
                    return [this.fchsTotalAlumni];
                case "ADVETI":
                    return [this.advetiTotalAlumni];
                default:
                    return [
                        this.atsTotalAlumni,
                        this.adpolyTotalAlumni,
                        this.fchsTotalAlumni,
                        this.advetiTotalAlumni,
                    ];
            }
        },
        chartOptions1() {
            const labels = this.getLabelBasedOnEntity();

            return {
                chart: {
                    width: 380,
                    type: "pie",
                },
                labels: labels,
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200,
                            },
                            legend: {
                                position: "bottom",
                            },
                        },
                    },
                ],
            };
        },
        series7() {
            return [this.registered, this.notRegistered];
        },
        chartOptions7() {
            const labelsWithCount = ["Alumni Registered", "Not Registered"].map(
                (label, index) => {
                    return `${label}: ${this.series7[index]}`;
                }
            );

            return {
                chart: {
                    width: 433,
                    type: "pie",
                },
                labels: labelsWithCount,
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200,
                            },
                            legend: {
                                position: "bottom",
                            },
                        },
                    },
                ],
                colors: ["#008000", "#ff0000"],
            };
        },
        series2() {
            return [this.employed, this.unEmployed, this.notUpdated];
        },
        chartOptions2() {
            const labelsWithCount = ["Employed", "Unemployed", "Not Contacted"].map(
                (label, index) => {
                    return `${label}: ${this.series2[index]}`;
                }
            );

            return {
                chart: {
                    width: 433,
                    type: "pie",
                },
                labels: labelsWithCount,
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200,
                            },
                            legend: {
                                position: "bottom",
                            },
                        },
                    },
                ],
                colors: ["#008000", "#ff0000", "#feb01a"],
            };
        },
        series3() {
            return [
                {
                    data: this.atsCampusCodeResults.map((result) => result.count),
                },
            ];
        },
        chartOptions3() {
            return {
                chart: {
                    type: "bar",
                    height: 350,
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                        barWidth: 20,
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    categories: this.atsCampusCodeResults.map(
                        (result) => result.campus_code
                    ),
                },
                tooltip: {
                    y: {
                        title: {
                            formatter: function () {
                                return "Total Alumni:";
                            },
                        },
                    },
                },
                colors: ["#008ffb"],
            };
        },
        series10() {
            return [
                {
                    data: this.atsGirlsCampusCodeResults.map((result) => result.count),
                },
            ];
        },
        chartOptions10() {
            return {
                chart: {
                    type: "bar",
                    height: 350,
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                        barWidth: 20,
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    categories: this.atsGirlsCampusCodeResults.map(
                        (result) => result.campus_code
                    ),
                },
                tooltip: {
                    y: {
                        title: {
                            formatter: function () {
                                return "Total Alumni:";
                            },
                        },
                    },
                },
                colors: ["#008ffb"],
            };
        },
        series4() {
            return [
                {
                    data: this.adpolyCampusCodeResults.map((result) => result.count),
                },
            ];
        },
        chartOptions4() {
            return {
                chart: {
                    type: "bar",
                    height: 350,
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    categories: this.adpolyCampusCodeResults.map(
                        (result) => result.campus_code
                    ),
                },
                tooltip: {
                    y: {
                        title: {
                            formatter: function () {
                                return "Total Alumni:";
                            },
                        },
                    },
                },
                colors: ["#8b75d7"],
            };
        },
        series5() {
            return [
                {
                    data: this.fchsCampusCodeResults.map((result) => result.count),
                },
            ];
        },
        chartOptions5() {
            return {
                chart: {
                    type: "bar",
                    height: 350,
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    categories: this.fchsCampusCodeResults.map(
                        (result) => result.campus_code
                    ),
                },
                tooltip: {
                    y: {
                        title: {
                            formatter: function () {
                                return "Total Alumni:";
                            },
                        },
                    },
                },
                colors: ["#feb01a"],
            };
        },
        series6() {
            return [
                {
                    data: this.advetiCampusCodeResults.map((result) => result.count),
                },
            ];
        },
        chartOptions6() {
            return {
                chart: {
                    type: "bar",
                    height: 350,
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    categories: this.advetiCampusCodeResults.map(
                        (result) => result.campus_code
                    ),
                },
                tooltip: {
                    y: {
                        title: {
                            formatter: function () {
                                return "Total Alumni:";
                            },
                        },
                    },
                },
                colors: ["#ff4560"],
            };
        },
        series8() {
            switch (this.filterByEntity) {
                case "ATHS":
                    return [
                        {
                            name: "ATS",
                            data: this.atsAcademicYearResults.map((result) => result.count),
                        },
                    ];
                case "ADPOLY":
                    return [
                        {
                            name: "ADPOLY",
                            data: this.adpolyAcademicYearResults.map(
                                (result) => result.count
                            ),
                        },
                    ];
                case "FCHS":
                    return [
                        {
                            name: "FCHS",
                            data: this.fchsAcademicYearResults.map((result) => result.count),
                        },
                    ];
                case "ADVETI":
                    return [
                        {
                            name: "ADVETI",
                            data: this.advetiAcademicYearResults.map(
                                (result) => result.count
                            ),
                        },
                    ];
                default:
                    return [
                        {
                            name: "ATS",
                            data: this.atsAcademicYearResults.map((result) => result.count),
                        },
                        {
                            name: "ADPOLY",
                            data: this.adpolyAcademicYearResults.map(
                                (result) => result.count
                            ),
                        },
                        {
                            name: "FCHS",
                            data: this.fchsAcademicYearResults.map((result) => result.count),
                        },
                        {
                            name: "ADVETI",
                            data: this.advetiAcademicYearResults.map(
                                (result) => result.count
                            ),
                        },
                    ];
            }
        },
        chartOptions8() {
            return {
                chart: {
                    type: "bar",
                    height: 350,
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "55%",
                        endingShape: "rounded",
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["transparent"],
                },
                xaxis: {
                    categories: this.academicYears,
                },
                yaxis: {
                    title: {
                        text: "No of alumni",
                    },
                },
                fill: {
                    opacity: 1,
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val;
                        },
                    },
                },
            };
        },
        series9() {
            var emSatAbove1000Data = [];
            var emSatBelow1000Data = [];

            if (this.filterByEmSatSubject) {
                switch (this.filterByEmSatSubject) {
                    case "em_sat_math":
                        emSatAbove1000Data = [this.emSatAbove1000Data[0], 0, 0, 0, 0, 0, 0];
                        emSatBelow1000Data = [this.emSatBelow1000Data[0], 0, 0, 0, 0, 0, 0];
                        break;
                    case "em_sat_phy":
                        emSatAbove1000Data = [0, this.emSatAbove1000Data[1], 0, 0, 0, 0, 0];
                        emSatBelow1000Data = [0, this.emSatBelow1000Data[1], 0, 0, 0, 0, 0];
                        break;
                    case "em_sat_eng":
                        emSatAbove1000Data = [0, 0, this.emSatAbove1000Data[2], 0, 0, 0, 0];
                        emSatBelow1000Data = [0, 0, this.emSatBelow1000Data[2], 0, 0, 0, 0];
                        break;
                    case "em_sat_arab":
                        emSatAbove1000Data = [0, 0, 0, this.emSatAbove1000Data[3], 0, 0, 0];
                        emSatBelow1000Data = [0, 0, 0, this.emSatBelow1000Data[3], 0, 0, 0];
                        break;
                    case "em_sat_chem":
                        emSatAbove1000Data = [0, 0, 0, 0, this.emSatAbove1000Data[4], 0, 0];
                        emSatBelow1000Data = [0, 0, 0, 0, this.emSatBelow1000Data[4], 0, 0];
                        break;
                    case "em_sat_bio":
                        emSatAbove1000Data = [0, 0, 0, 0, 0, this.emSatAbove1000Data[5], 0];
                        emSatBelow1000Data = [0, 0, 0, 0, 0, this.emSatBelow1000Data[5], 0];
                        break;
                    case "em_sat_cse":
                        emSatAbove1000Data = [0, 0, 0, 0, 0, 0, this.emSatAbove1000Data[6]];
                        emSatBelow1000Data = [0, 0, 0, 0, 0, 0, this.emSatBelow1000Data[6]];
                        break;
                    default:
                        emSatAbove1000Data = this.emSatAbove1000Data;
                        emSatBelow1000Data = this.emSatBelow1000Data;
                }
            } else {
                emSatAbove1000Data = this.emSatAbove1000Data;
                emSatBelow1000Data = this.emSatBelow1000Data;
            }

            return [
                {
                    name: "Above 1100",
                    data: emSatAbove1000Data,
                },
                {
                    name: "Below 1100",
                    data: emSatBelow1000Data,
                },
            ];
        },
        chartOptions9() {
            return {
                chart: {
                    type: "bar",
                    height: 430,
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        dataLabels: {
                            position: "top",
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetX: -6,
                    style: {
                        fontSize: "12px",
                        colors: ["#fff"],
                    },
                },
                stroke: {
                    show: true,
                    width: 1,
                    colors: ["#fff"],
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                },
                xaxis: {
                    categories: ["MAT", "PHY", "ENG", "ARB", "CHE", "BIO", "CSE"],
                },
                colors: ["#00e396", "#ff4560"],
            };
        },
        countryData() {
            return this.universityCountryResults;
        },
        totalEmploymentRate() {
            const total = this.employed + this.unEmployed;
            if (total) {
                const percentage = ((this.employed / total) * 100).toFixed(2);

                let color = "text-red-600";
                if (percentage >= 75) {
                    color = "text-green-600";
                } else if (percentage >= 50) {
                    color = "text-green-400";
                } else if (percentage >= 25) {
                    color = "text-yellow-600";
                }

                return `<div class="font-bold text-lg ${color}">${percentage}%</div>`;
            } else {
                return `<div class="font-bold text-lg text-red-600">0%</div>`;
            }
        },
    },
    apollo: {
        entities() {
            return {
                query: gql`
          query GetEntityList {
            entities {
              data {
                entity
              }
            }
          }
        `,
                fetchPolicy: "cache-and-network",
            };
        },
        students() {
            return {
                query: gql`
          query GetAllStudents(
            $first: Int!
            $page: Int!
            $search: String
            $entity: String
            $academic_years: [String]
            $student_status: String
            $campuses: [String]
            $colleges: [String]
            $local_or_non_local: String
            $gender: String
            $filter_by_registration: String
            $is_employed: String
            $employer: String
            $emp_pos: String
            $emp_loc: String
            $emp_sector: String
            $stream: String
            $university_country: String
            $program_of_entry: String
            $university_name: String
            $study_in_uae: String
            $major: String
            $specialization: String
            $program_degree_desc: String
            $filter_by_em_sat_subject: String
            $filter_by_em_sat_value: String
          ) {
            students(
              first: $first
              page: $page
              search: $search
              entity: $entity
              academic_years: $academic_years
              student_status: $student_status
              campuses: $campuses
              colleges: $colleges
              local_or_non_local: $local_or_non_local
              gender: $gender
              filter_by_registration: $filter_by_registration
              is_employed: $is_employed
              employer: $employer
              emp_pos: $emp_pos
              emp_loc: $emp_loc
              emp_sector: $emp_sector
              stream: $stream
              university_country: $university_country
              program_of_entry: $program_of_entry
              university_name: $university_name
              study_in_uae: $study_in_uae
              major: $major
              specialization: $specialization
              program_degree_desc: $program_degree_desc
              filter_by_em_sat_subject: $filter_by_em_sat_subject
              filter_by_em_sat_value: $filter_by_em_sat_value
            ) {
              data {
                user_id
                name_ar
                name_en
                student_id
                entity
                campus_code
                eid
                program_code
                program_name
                study_program
                cluster_e
                is_employed
                academic_year
                ay
                grad_year
                university_name
                employmentInformations {
                  employer
                  position
                  aprehis_empl_position
                }
                profile_picture_url
              }
              paginatorInfo {
                count
                currentPage
                firstItem
                hasMorePages
                lastItem
                lastPage
                perPage
                total
              }
            }
          }
        `,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        search: this.searchText,
                        entity: this.filterByEntity,
                        academic_years: this.filterByAcademicYears,
                        specialization: this.filterBySpecialization,
                        stream: this.filterByStream,
                        university_country: this.filterByUniversityCountry,
                        program_of_entry: this.filterByProgramOfEntry,
                        program_degree_desc: this.filterByDegree,
                        filter_by_em_sat_subject: this.filterByEmSatSubject,
                        filter_by_em_sat_value: this.filterByEmSatValue,
                        university_name: this.filterByUniversityName,
                        study_in_uae: this.filterByStudyStatus,
                        major: this.filterByMajor,
                        student_status: this.filterByStatus,
                        campuses: this.filterByCampuses,
                        colleges: this.filterByColleges,
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        gender: this.filterByGender,
                        filter_by_registration: this.filterByRegistration,
                        is_employed: this.filterByEmploymentStatus,
                        employer: this.filterByEmployer,
                        emp_pos: this.filterByDesignation,
                        emp_loc: this.filterByEmployerLocation,
                        emp_sector: this.filterBySector,
                    };
                },
                fetchPolicy: "cache-and-network",
            };
        },
    },
    methods: {
        collapseDropDown(dropDownName = "") {
            if (dropDownName) {
                if (dropDownName != "campus") {
                    this.showCampusDropDown = false;
                }
                if (dropDownName != "academic_year") {
                    this.showAcademicYearDropDown = false;
                }
                if (dropDownName != "college") {
                    this.showCollegeDropDown = false;
                }
            } else {
                this.showCampusDropDown = false;
                this.showAcademicYearDropDown = false;
                this.showCollegeDropDown = false;
            }
        },
        clearAllFilter(filterName = "") {
            if (!filterName) {
                this.filterByEntity = "";
            }
            this.filterByCampuses = [];
            this.filterByColleges = [];
            this.filterByLocalOrNonLocal = "";
            this.filterByGender = "";
            this.filterByRegistration = "";
            this.filterByEmploymentStatus = "0";
            this.filterByEmployer = "";
            this.filterByDesignation = "";
            this.filterByEmployerLocation = "";
            this.filterBySector = "";
            this.filterByAcademicYears = [];
            this.filterBySpecialization = "";
            this.filterByEmSatSubject = "";
            this.filterByEmSatValue = "";
            this.filterByDegree = "";
            this.filterByUniversityName = "";
            this.filterByStudyStatus = "";
            this.filterByMajor = "";
            this.filterByStream = "";
            this.filterByUniversityCountry = "";
            this.filterByProgramOfEntry = "";
        },
        async getEmployerList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetEmployerList($student_status: String, $entity: String) {
              getEmployerList(student_status: $student_status, entity: $entity)
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                    fetchPolicy: "network-only",
                });
                this.employerList = data.getEmployerList;
            } catch (error) {
                console.log(error);
            }
        },
        async getDesignationList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetDesignationList(
              $student_status: String
              $entity: String
              $employer: String
            ) {
              getDesignationList(
                student_status: $student_status
                entity: $entity
                employer: $employer
              )
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                        employer: this.filterByEmployer,
                    },
                    fetchPolicy: "network-only",
                });
                this.designationList = data.getDesignationList;
            } catch (error) {
                console.log(error);
            }
        },
        async getEmployerLocationList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetEmployerLocationList(
              $student_status: String
              $entity: String
              $employer: String
            ) {
              getEmployerLocationList(
                student_status: $student_status
                entity: $entity
                employer: $employer
              )
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                        employer: this.filterByEmployer,
                    },
                    fetchPolicy: "network-only",
                });
                this.employerLocationList = data.getEmployerLocationList;
            } catch (error) {
                console.log(error);
            }
        },
        async getAcademicYears() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetAcademicYears($student_status: String, $entity: String) {
              getAcademicYears(student_status: $student_status, entity: $entity)
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                    fetchPolicy: "network-only",
                });
                this.academicYearsList = data.getAcademicYears;
            } catch (error) {
                console.log(error);
            }
        },
        async getSpecializations() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetSpecializations(
              $student_status: String
              $entity: String
              $academic_year: [String]
            ) {
              getSpecializations(
                student_status: $student_status
                entity: $entity
                academic_year: $academic_year
              )
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                        academic_year: this.filterByAcademicYears,
                    },
                });
                this.specializationsList = data.getSpecializations;
            } catch (error) {
                console.log(error);
            }
        },
        async getSponsorsList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetSponsorsList($student_status: String, $entity: String) {
              getSponsorsList(student_status: $student_status, entity: $entity)
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                    fetchPolicy: "network-only",
                });
                this.sponsorsList = data.getSponsorsList;
            } catch (error) {
                console.log(error);
            }
        },
        async getUniversityNames() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetUniversityNames(
              $student_status: String
              $entity: String
              $university_country: String
            ) {
              getUniversityNames(
                student_status: $student_status
                entity: $entity
                university_country: $university_country
              )
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                        university_country: this.filterByUniversityCountry,
                    },
                });
                this.universityNamesList = data.getUniversityNames;
            } catch (error) {
                console.log(error);
            }
        },
        async getMajors() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetMajors($student_status: String, $entity: String) {
              getMajors(student_status: $student_status, entity: $entity)
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                });
                this.majorsList = data.getMajors;
            } catch (error) {
                console.log(error);
            }
        },
        async getCollegesList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetCollegesList($student_status: String, $entity: String) {
              getCollegesList(student_status: $student_status, entity: $entity)
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                });
                this.collegesList = data.getCollegesList;
            } catch (error) {
                console.log(error);
            }
        },
        async getUniversityCountries() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetUniversityCountries(
              $student_status: String
              $entity: String
            ) {
              getUniversityCountries(
                student_status: $student_status
                entity: $entity
              )
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                });
                this.universityCountryList = data.getUniversityCountries;
            } catch (error) {
                console.log(error);
            }
        },
        async getCampusList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GetCampusList($student_status: String, $entity: String) {
              getCampusList(student_status: $student_status, entity: $entity) {
                entity
                campus_code
              }
            }
          `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                    fetchPolicy: "network-only",
                });
                this.campusList = data.getCampusList;
            } catch (error) {
                console.log(error);
            }
        },
        getLabelBasedOnEntity() {
            switch (this.filterByEntity) {
                case "ATHS":
                    return ["ATS"];
                case "ADPOLY":
                    return ["ADPOLY"];
                case "FCHS":
                    return ["FCHS"];
                case "ADVETI":
                    return ["ADVETI"];
                default:
                    return ["ATS", "ADPOLY", "FCHS", "ADVETI"];
            }
        },
        async getAlumniDashboard() {
            if (this.showDashboard) {
                this.isDashboardLoading = true;
                try {
                    const { data } = await this.$apollo.query({
                        query: gql`
            query GetAlumniDashboard(
              $entity: String
              $campuses: [String]
              $colleges: [String]
              $local_or_non_local: String
              $gender: String
              $filter_by_registration: String
              $is_employed: String
              $employer: String
              $emp_pos: String
              $emp_loc: String
              $emp_sector: String
              $academic_year: [String]
              $university_country: String
              $stream: String
              $program_of_entry: String
              $university_name: String
              $study_in_uae: String
              $major: String
              $specialization: String
              $program_degree_desc: String
              $filter_by_em_sat_subject: String
              $filter_by_em_sat_value: String
              $student_status: String
            ) {
              getAlumniDashboard(
                entity: $entity
                campuses: $campuses
                colleges: $colleges
                local_or_non_local: $local_or_non_local
                gender: $gender
                filter_by_registration: $filter_by_registration
                is_employed: $is_employed
                employer: $employer
                emp_pos: $emp_pos
                emp_loc: $emp_loc
                emp_sector: $emp_sector
                academic_year: $academic_year
                stream: $stream
                university_country: $university_country
                program_of_entry: $program_of_entry
                university_name: $university_name
                study_in_uae: $study_in_uae
                major: $major
                specialization: $specialization
                program_degree_desc: $program_degree_desc
                filter_by_em_sat_subject: $filter_by_em_sat_subject
                filter_by_em_sat_value: $filter_by_em_sat_value
                student_status: $student_status
              ) {
                data {
                  total_alumni
                  ats_total_alumni
                  adpoly_total_alumni
                  fchs_total_alumni
                  adveti_total_alumni
                  registered
                  not_registered
                  employed
                  unemployed
                  not_updated
                  ats_campus_code_results {
                    campus_code
                    count
                  }
                  adpoly_campus_code_results {
                    campus_code
                    count
                  }
                  fchs_campus_code_results {
                    campus_code
                    count
                  }
                  adveti_campus_code_results {
                    campus_code
                    count
                  }
                  academic_years
                  ats_academic_year_results {
                    academic_year
                    count
                  }
                  fchs_academic_year_results {
                    academic_year
                    count
                  }
                  adpoly_academic_year_results {
                    academic_year
                    count
                  }
                  adveti_academic_year_results {
                    academic_year
                    count
                  }
                  university_country_query_results {
                    university_country_code
                    university_country
                    count
                  }
                  ats_em_sat_math_query_results {
                    subject
                    above_1100
                    below_1100
                  }
                  ats_em_sat_phy_query_results {
                    subject
                    above_1100
                    below_1100
                  }
                  ats_em_sat_eng_query_results {
                    subject
                    above_1100
                    below_1100
                  }
                  ats_em_sat_arab_query_results {
                    subject
                    above_1100
                    below_1100
                  }
                  ats_em_sat_chem_query_results {
                    subject
                    above_1100
                    below_1100
                  }
                  ats_em_sat_bio_query_results {
                    subject
                    above_1100
                    below_1100
                  }
                  ats_em_sat_cse_query_results {
                    subject
                    above_1100
                    below_1100
                  }
                  ats_employed
                  ats_unemployed
                  adpoly_employed
                  adpoly_unemployed
                  fchs_employed
                  fchs_unemployed
                  adveti_employed
                  adveti_unemployed
                }
              }
            }
          `,
                        variables: {
                            entity: this.filterByEntity,
                            campuses: this.filterByCampuses,
                            colleges: this.filterByColleges,
                            local_or_non_local: this.filterByLocalOrNonLocal,
                            gender: this.filterByGender,
                            filter_by_registration: this.filterByRegistration,
                            is_employed: this.filterByEmploymentStatus,
                            employer: this.filterByEmployer,
                            emp_pos: this.filterByDesignation,
                            emp_loc: this.filterByEmployerLocation,
                            emp_sector: this.filterBySector,
                            academic_year: this.filterByAcademicYears,
                            specialization: this.filterBySpecialization,
                            stream: this.filterByStream,
                            university_country: this.filterByUniversityCountry,
                            program_of_entry: this.filterByProgramOfEntry,
                            university_name: this.filterByUniversityName,
                            study_in_uae: this.filterByStudyStatus,
                            major: this.filterByMajor,
                            program_degree_desc: this.filterByDegree,
                            filter_by_em_sat_subject: this.filterByEmSatSubject,
                            filter_by_em_sat_value: this.filterByEmSatValue,
                            student_status: this.filterByStatus,
                        },
                        fetchPolicy: "network-only",
                    });

                    const alumniDashboardData = data.getAlumniDashboard.data;

                    this.totalAlumni = alumniDashboardData.total_alumni;
                    this.atsTotalAlumni = alumniDashboardData.ats_total_alumni;
                    this.adpolyTotalAlumni = alumniDashboardData.adpoly_total_alumni;
                    this.fchsTotalAlumni = alumniDashboardData.fchs_total_alumni;
                    this.advetiTotalAlumni = alumniDashboardData.adveti_total_alumni;

                    this.registered = alumniDashboardData.registered;
                    this.notRegistered = alumniDashboardData.not_registered;

                    this.employed = alumniDashboardData.employed;
                    this.unEmployed = alumniDashboardData.unemployed;
                    this.notUpdated = alumniDashboardData.not_updated;

                    this.atsEmployed = alumniDashboardData.ats_employed;
                    this.atsUnEmployed = alumniDashboardData.ats_unemployed;
                    this.adpolyEmployed = alumniDashboardData.adpoly_employed;
                    this.adpolyUnEmployed = alumniDashboardData.adpoly_unemployed;
                    this.fchsEmployed = alumniDashboardData.fchs_employed;
                    this.fchsUnEmployed = alumniDashboardData.fchs_unemployed;
                    this.advetiEmployed = alumniDashboardData.adveti_employed;
                    this.advetiUnEmployed = alumniDashboardData.adveti_unemployed;

                    const atsCampusCodeResults =
                        alumniDashboardData.ats_campus_code_results;

                    const boysCampus = [
                        "AUH-B",
                        "AUH-B-BANIYAS",
                        "Al Ain - B",
                        "AIN-B-TBMEC",
                        "AIN-B-AQB",
                        "AIN-B-HILI",
                        "DHF-B",
                        "DXB-B",
                        "SHJ-B",
                        "AJM-B",
                        "UAQ-B",
                        "RAK-B",
                        "FUJ-B",
                        "Delma - B",
                    ];
                    const girlsCampus = [
                        "AUH-G",
                        "AUH-G-BANIYAS",
                        "Al Ain - G",
                        "AIN-G-TBMEC",
                        "AIN-G-AQB",
                        "AIN-G-HILI",
                        "DHF-G",
                        "AJM-G",
                        "UAQ-G",
                        "Delma - G",
                    ];

                    this.atsCampusCodeResults = atsCampusCodeResults.filter((item) =>
                        boysCampus.includes(item.campus_code)
                    );
                    this.atsGirlsCampusCodeResults = atsCampusCodeResults.filter((item) =>
                        girlsCampus.includes(item.campus_code)
                    );

                    this.atsCampusCodeResults.sort(
                        (a, b) =>
                            boysCampus.indexOf(a.campus_code) -
                            boysCampus.indexOf(b.campus_code)
                    );
                    this.atsGirlsCampusCodeResults.sort(
                        (a, b) =>
                            girlsCampus.indexOf(a.campus_code) -
                            girlsCampus.indexOf(b.campus_code)
                    );

                    this.adpolyCampusCodeResults =
                        alumniDashboardData.adpoly_campus_code_results;
                    this.fchsCampusCodeResults =
                        alumniDashboardData.fchs_campus_code_results;
                    this.advetiCampusCodeResults =
                        alumniDashboardData.adveti_campus_code_results;

                    this.academicYears = alumniDashboardData.academic_years;
                    const atsAcademicYearResults =
                        alumniDashboardData.ats_academic_year_results;
                    const fchsAcademicYearResults =
                        alumniDashboardData.fchs_academic_year_results;
                    const adpolyAcademicYearResults =
                        alumniDashboardData.adpoly_academic_year_results;
                    const advetiAcademicYearResults =
                        alumniDashboardData.adveti_academic_year_results;

                    this.universityCountryResultsList =
                        alumniDashboardData.university_country_query_results;
                    this.universityCountryResults = this.universityCountryResultsList.reduce(
                        (result, item) => {
                            result[item.university_country_code] = item.count;
                            return result;
                        },
                        {}
                    );

                    for (const key in this.universityCountryResults) {
                        if (!this.universityCountryCodeList.includes(key)) {
                            this.universityCountryCodeList.push(key);
                        }
                    }

                    this.atsAcademicYearResults = this.academicYears.map((year) => ({
                        academic_year: year,
                        count: 0,
                    }));
                    this.fchsAcademicYearResults = this.academicYears.map((year) => ({
                        academic_year: year,
                        count: 0,
                    }));
                    this.adpolyAcademicYearResults = this.academicYears.map((year) => ({
                        academic_year: year,
                        count: 0,
                    }));
                    this.advetiAcademicYearResults = this.academicYears.map((year) => ({
                        academic_year: year,
                        count: 0,
                    }));

                    atsAcademicYearResults.forEach((item) => {
                        const index = this.academicYears.indexOf(item.academic_year);
                        if (index !== -1) {
                            this.atsAcademicYearResults[index].count = item.count;
                        }
                    });
                    fchsAcademicYearResults.forEach((item) => {
                        const index = this.academicYears.indexOf(item.academic_year);
                        if (index !== -1) {
                            this.fchsAcademicYearResults[index].count = item.count;
                        }
                    });
                    adpolyAcademicYearResults.forEach((item) => {
                        const index = this.academicYears.indexOf(item.academic_year);
                        if (index !== -1) {
                            this.adpolyAcademicYearResults[index].count = item.count;
                        }
                    });
                    advetiAcademicYearResults.forEach((item) => {
                        const index = this.academicYears.indexOf(item.academic_year);
                        if (index !== -1) {
                            this.advetiAcademicYearResults[index].count = item.count;
                        }
                    });

                    this.emSatAbove1000Data = [
                        alumniDashboardData.ats_em_sat_math_query_results[0].above_1100,
                        alumniDashboardData.ats_em_sat_phy_query_results[0].above_1100,
                        alumniDashboardData.ats_em_sat_eng_query_results[0].above_1100,
                        alumniDashboardData.ats_em_sat_arab_query_results[0].above_1100,
                        alumniDashboardData.ats_em_sat_chem_query_results[0].above_1100,
                        alumniDashboardData.ats_em_sat_bio_query_results[0].above_1100,
                        alumniDashboardData.ats_em_sat_cse_query_results[0].above_1100,
                    ];

                    this.emSatBelow1000Data = [
                        alumniDashboardData.ats_em_sat_math_query_results[0].below_1100,
                        alumniDashboardData.ats_em_sat_phy_query_results[0].below_1100,
                        alumniDashboardData.ats_em_sat_eng_query_results[0].below_1100,
                        alumniDashboardData.ats_em_sat_arab_query_results[0].below_1100,
                        alumniDashboardData.ats_em_sat_chem_query_results[0].below_1100,
                        alumniDashboardData.ats_em_sat_bio_query_results[0].below_1100,
                        alumniDashboardData.ats_em_sat_cse_query_results[0].below_1100,
                    ];
                } catch (error) {
                    console.log(error);
                }
                this.isDashboardLoading = false;
            }
        },
        getEntityName(entity) {
            if (entity == "ATHS") {
                return "ATS";
            } else {
                return entity;
            }
        },
        getGender(gender) {
            if (gender) {
                if (gender == "M") {
                    return "Male";
                } else {
                    return "Female";
                }
            } else {
                return "";
            }
        },
        formatDate(dateString) {
            if (!dateString) return "";
            const [year, month, day] = dateString.split("-");
            return `${day}-${month}-${year}`;
        },
        getSpecialization(
            entity,
            studyProgram,
            programName,
            programCode,
            clusterE
        ) {
            let specialization = "";
            if (entity == "ATHS") {
                if (clusterE) {
                    specialization = clusterE;
                } else if (programName) {
                    specialization = programName;
                } else if (studyProgram) {
                    specialization = studyProgram;
                } else {
                    specialization = programCode;
                }
            } else {
                if (programName) {
                    specialization = programName;
                } else if (studyProgram) {
                    specialization = studyProgram;
                } else {
                    specialization = programCode;
                }
            }
            return specialization;
        },
        getEmployerName(isEmployed, employerInformation) {
            if (isEmployed) {
                if (employerInformation) {
                    return employerInformation.employer;
                } else {
                    return "Not Contacted";
                }
            } else {
                if (employerInformation) {
                    return employerInformation.employer;
                } else {
                    return "Unemployed";
                }
            }
        },
        getDesignation(employerInformation) {
            if (employerInformation) {
                if (employerInformation.position) {
                    return employerInformation.position;
                } else {
                    return employerInformation.aprehis_empl_position;
                }
            } else {
                return "";
            }
        },
        getAcademicYear(academicYear, AY) {
            if (academicYear) {
                return academicYear;
            } else if (AY) {
                return AY;
            } else {
                return "";
            }
        },
        getGraduationYear(gradYear, academicYearGraduation) {
            if (gradYear) {
                return gradYear;
            } else if (academicYearGraduation) {
                return academicYearGraduation;
            } else {
                return "";
            }
        },
        getPlaceOfStudy(studyInUae) {
            if (studyInUae === 1) {
                return "United Arab Emirates";
            } else if (studyInUae === 0) {
                return "Abroad";
            } else {
                return "";
            }
        },
        isRegistered(userId) {
            if (userId) {
                return "Yes";
            } else {
                return "No";
            }
        },
        isShowChart(entity) {
            if (this.filterByEntity == "") {
                if (this.role == "superadmin" || this.userEntities === null) {
                    return true;
                } else {
                    const entitiesArray = this.userEntities.split(",");
                    if (entitiesArray.includes(entity)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return this.filterByEntity == entity;
            }
        },
        setPage(page) {
            this.page = page;
        },
        onUpdateStudent() {
            // this.$apollo.queries.students.refetch();

            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });

            Toast.fire({
                icon: "success",
                title: "Student Details Updated Successfully",
            });

            this.closeEditStudentModal();
        },
        viewStudent(id, name) {
            this.studentId = id;
            this.modalTitle = name;
            this.openviewStudentModal = true;
        },
        closeViewStudentModal() {
            this.openviewStudentModal = false;
            this.modalTitle = "";
            this.studentId = null;
        },
        editStudent(id, name) {
            this.studentId = id;
            this.modalTitle = name;
            this.editStudentModal = true;
        },
        closeEditStudentModal() {
            this.editStudentModal = false;
            this.modalTitle = "";
            this.studentId = null;
        },
        getProfilePicture(profilePictureUrl, studentId, entity) {
            if (profilePictureUrl) {
                if (
                    profilePictureUrl ==
                    "/storage/alumni-profile-pictures/default-avatar.jpg"
                ) {
                    return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
                } else {
                    return process.env.VUE_APP_PUBLIC_URL + profilePictureUrl;
                }
            } else {
                return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
            }
        },
        onSearch(searchText) {
            this.searchText = searchText;
        },
        openPreviewImgModal(profilePictureUrl, studentId, entity) {
            if (profilePictureUrl) {
                if (
                    profilePictureUrl ==
                    "/storage/alumni-profile-pictures/default-avatar.jpg"
                ) {
                    this.previewImg = `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
                } else {
                    this.previewImg = process.env.VUE_APP_PUBLIC_URL + profilePictureUrl;
                }
            } else {
                this.previewImg = `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
            }
            this.previewImageModal = true;
        },
        closePreviewImageModal() {
            this.previewImageModal = false;
            this.previewImg = "";
        },
        hasPermission(crudName) {
            if (this.role == "superadmin") {
                return true;
            } else {
                const permissions = this.$store.getters.permissions;
                const permissionsArray = permissions.split(",");
                if (permissionsArray.includes(crudName)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        async generateReport() {
            var page = 1;
            var limit = 200;
            this.isExportExcel = true;
            this.isApiCallRecurisive = true;

            try {
                while (this.isApiCallRecurisive) {
                    try {
                        const responseData = await this.fetchForExporting(page, limit);

                        if (responseData.data && responseData.data.length > 0) {
                            this.generatedReport.push(
                                ...responseData.data.map((obj) => {
                                    return {
                                        student_id: obj.student_id,
                                        eid: obj.eid,
                                        name_en: obj.name_en,
                                        name_ar: obj.name_ar,
                                        gender: this.getGender(obj.gender),
                                        birthdate: this.formatDate(obj.birthdate),
                                        entity: this.getEntityName(obj.entity),
                                        campus: obj.campus_code,
                                        program_name: this.getSpecialization(
                                            obj.entity,
                                            obj.study_program,
                                            obj.program_name,
                                            obj.program_code,
                                            obj.cluster_e
                                        ),
                                        ...(this.isATS ? { stream: obj.stream } : {}),
                                        alumni_phone: obj.alumni_phone || "",
                                        primary_phone: obj.primary_phone || "",
                                        secondary_phone: obj.secondary_phone || "",
                                        primary_email: obj.primary_email || "",
                                        secondary_email: obj.secondary_email || "",
                                        local_or_non_local: obj.local_or_non_local,
                                        academic_year: this.getAcademicYear(obj.academic_year, obj.ay),
                                        grad_year: this.getGraduationYear(
                                            obj.grad_year,
                                            obj.academic_year_graduation
                                        ),
                                        university_country: obj.university_country,
                                        university_name: obj.university_name,
                                        college: obj.college,
                                        major: obj.major,
                                        current_status: obj.current_status,
                                        current_status_reason: obj.current_status_reason,
                                        is_employed: obj.is_employed ? "Yes" : "No",
                                        employer: this.getEmployerName(
                                            obj.is_employed,
                                            obj.employmentInformations
                                        ),
                                        designation: this.getDesignation(obj.employmentInformations),
                                        registered: this.isRegistered(obj.user_id),
                                    };
                                })
                            );
                            page++;
                        } else {
                            this.isApiCallRecurisive = false;
                            break;
                        }
                    } catch (error) {
                        console.error(`Error fetching page ${page}:`, error);

                        // Show error to user but continue with partial data
                        this.$swal.fire({
                            icon: 'warning',
                            title: 'Export Warning',
                            text: `Error occurred while fetching page ${page}. Exporting partial data.`,
                            timer: 3000,
                            showConfirmButton: false
                        });

                        this.isApiCallRecurisive = false;
                        break;
                    }
                }

                if (this.generatedReport.length > 0) {
                    this.exportToExcel("Unemployed_Graduates");
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Export Failed',
                        text: 'No data available for export.',
                    });
                }
            } catch (error) {
                console.error('Error in generateReport:', error);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Export Failed',
                    text: 'An error occurred while generating the report.',
                });
            } finally {
                this.isExportExcel = false;
                this.isApiCallRecurisive = false;
            }
        },
        async fetchForExporting(pageNo = 1, limitSize = 50) {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
            query GenerateStudentsReport(
              $page: Int
              $limit: Int
              $search: String
              $entity: String
              $academic_years: [String]
              $student_status: String
              $campuses: [String]
              $colleges: [String]
              $local_or_non_local: String
              $gender: String
              $filter_by_registration: String
              $is_employed: String
              $employer: String
              $emp_pos: String
              $emp_loc: String
              $emp_sector: String
              $stream: String
              $university_country: String
              $program_of_entry: String
              $university_name: String
              $study_in_uae: String
              $major: String
              $specialization: String
              $program_degree_desc: String
              $filter_by_em_sat_subject: String
              $filter_by_em_sat_value: String
            ) {
              generateStudentsReport(
                page: $page
                limit: $limit
                search: $search
                entity: $entity
                academic_years: $academic_years
                student_status: $student_status
                campuses: $campuses
                colleges: $colleges
                local_or_non_local: $local_or_non_local
                gender: $gender
                filter_by_registration: $filter_by_registration
                is_employed: $is_employed
                employer: $employer
                emp_pos: $emp_pos
                emp_loc: $emp_loc
                emp_sector: $emp_sector
                stream: $stream
                university_country: $university_country
                program_of_entry: $program_of_entry
                university_name: $university_name
                study_in_uae: $study_in_uae
                major: $major
                specialization: $specialization
                program_degree_desc: $program_degree_desc
                filter_by_em_sat_subject: $filter_by_em_sat_subject
                filter_by_em_sat_value: $filter_by_em_sat_value
              ) {
                error
                error_code
                message
                data {
                  student_id
                  user_id
                  eid
                  name_en
                  name_ar
                  gender
                  birthdate
                  entity
                  campus_code
                  program_name
                  stream
                  study_program
                  program_code
                  cluster_e
                  primary_email
                  secondary_email
                  alumni_phone
                  primary_phone
                  secondary_phone
                  local_or_non_local
                  academic_year
                  ay
                  grad_year
                  academic_year_graduation
                  is_employed
                  university_country
                  university_name
                  college
                  major
                  current_status
                  current_status_reason
                  employmentInformations {
                    employer
                    position
                    aprehis_empl_position
                  }
                }
              }
            }
          `,
                    fetchPolicy: "network-only",
                    errorPolicy: 'all', // Continue on GraphQL errors
                    variables: {
                        page: pageNo,
                        limit: limitSize,
                        search: this.searchText,
                        entity: this.filterByEntity,
                        academic_years: this.filterByAcademicYears,
                        specialization: this.filterBySpecialization,
                        stream: this.filterByStream,
                        university_country: this.filterByUniversityCountry,
                        program_of_entry: this.filterByProgramOfEntry,
                        program_degree_desc: this.filterByDegree,
                        filter_by_em_sat_subject: this.filterByEmSatSubject,
                        filter_by_em_sat_value: this.filterByEmSatValue,
                        university_name: this.filterByUniversityName,
                        study_in_uae: this.filterByStudyStatus,
                        major: this.filterByMajor,
                        student_status: this.filterByStatus,
                        campuses: this.filterByCampuses,
                        colleges: this.filterByColleges,
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        gender: this.filterByGender,
                        filter_by_registration: this.filterByRegistration,
                        is_employed: this.filterByEmploymentStatus,
                        employer: this.filterByEmployer,
                        emp_pos: this.filterByDesignation,
                        emp_loc: this.filterByEmployerLocation,
                        emp_sector: this.filterBySector,
                    },
                });

                const responseData = data.generateStudentsReport;

                // Check for errors in the response
                if (responseData.error) {
                    throw new Error(responseData.message || 'Server error occurred');
                }

                return responseData;
            } catch (error) {
                console.error('Error fetching data for export:', error);
                throw error; // Re-throw to handle in calling method
            }
        },
        exportToExcel(reportName) {
            const XLSX = xlsx;

            let header = [
                "STUDENT ID",
                "EID",
                "NAME IN ENGLISH",
                "NAME IN ARABIC",
                "GENDER",
                "DATE OF BIRTH",
                "ENTITY",
                "CAMPUS",
                "PROGRAM NAME",
            ];

            if (this.isATS) {
                header.push("STREAM");
            }

            let additionalFields = [
                "ALUMNI PHONE",
                "PRIMARY PHONE",
                "SECONDARY PHONE",
                "PRIMARY EMAIL",
                "SECONDARY EMAIL",
                "LOCAL OR NON LOCAL",
                "ACADEMIC YEAR",
                "GRADUATED YEAR",
                "UNIVERSITY COUNTRY",
                "UNIVERSITY NAME",
                "COLLEGE",
                "MAJOR",
                "CURRENT STATUS",
                "CURRENT STATUS REASON",
                "IS EMPLOYED",
                "EMPLOYER",
                "DESIGNATION",
                "IS REGISTERED",
            ];

            header = header.concat(additionalFields);

            const worksheet = XLSX.utils.json_to_sheet(this.generatedReport);

            worksheet["A1"] = { v: header[0], t: "s" };
            worksheet["B1"] = { v: header[1], t: "s" };
            worksheet["C1"] = { v: header[2], t: "s" };
            worksheet["D1"] = { v: header[3], t: "s" };
            worksheet["E1"] = { v: header[4], t: "s" };
            worksheet["F1"] = { v: header[5], t: "s" };
            worksheet["G1"] = { v: header[6], t: "s" };
            worksheet["H1"] = { v: header[7], t: "s" };
            worksheet["I1"] = { v: header[8], t: "s" };
            worksheet["J1"] = { v: header[9], t: "s" };
            worksheet["K1"] = { v: header[10], t: "s" };
            worksheet["L1"] = { v: header[11], t: "s" };
            worksheet["M1"] = { v: header[12], t: "s" };
            worksheet["N1"] = { v: header[13], t: "s" };
            worksheet["O1"] = { v: header[14], t: "s" };
            worksheet["P1"] = { v: header[15], t: "s" };
            worksheet["Q1"] = { v: header[16], t: "s" };
            worksheet["R1"] = { v: header[17], t: "s" };
            worksheet["S1"] = { v: header[18], t: "s" };
            worksheet["T1"] = { v: header[19], t: "s" };
            worksheet["U1"] = { v: header[20], t: "s" };
            worksheet["V1"] = { v: header[21], t: "s" };
            worksheet["W1"] = { v: header[22], t: "s" };
            worksheet["X1"] = { v: header[23], t: "s" };
            worksheet["Y1"] = { v: header[24], t: "s" };
            worksheet["Z1"] = { v: header[25], t: "s" };
            worksheet["Z1"] = { v: header[25], t: "s" };
            worksheet["AA1"] = { v: header[26], t: "s" };
            if (this.isATS) {
                worksheet["AB1"] = { v: header[27], t: "s" };
            }

            worksheet["!cols"] = [
                { width: 40 },
                { width: 40 },
                { width: 30 },
                { width: 30 },
                { width: 20 },
                { width: 30 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
            ];

            // Add width for 'STREAM' if isATS is true
            if (this.isATS) {
                worksheet["!cols"].push({ width: 30 });
            }

            worksheet["!cols"] = worksheet["!cols"].concat([
                { width: 40 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 40 },
                { width: 20 },
                { width: 40 },
                { width: 30 },
                { width: 20 },
            ]);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, `${reportName}.xlsx`);
            this.generatedReport = [];
            this.isExportExcel = false;
            this.isApiCallRecurisive = false;
        },
        closeFullModal() {
            this.showFullModal = false;
            this.showStudentProfileFullModal = false;
            this.studentId = null;
        },
        getMaritalStatus(status) {
            if (status == "S") {
                return "Single";
            } else if (status == "M") {
                return "Married";
            } else if (status == "W") {
                return "Widowed";
            } else if (status == "D") {
                return "Divorced";
            } else if (status == "U") {
                return "Unmarried";
            } else {
                return "";
            }
        },
        formattedDate(date) {
            if (date) {
                const parsedDate = new Date(date);
                return parsedDate
                    .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                    })
                    .replace(/\//g, "-");
            } else {
                return "";
            }
        },
        viewStudentProfile(studentId) {
            this.studentId = studentId;
            this.showStudentProfileFullModal = true;
        },
        async generatePdf(studentId) {
            document.body.classList.add("loading");
            this.isGenerateReport = true;

            const GENERATE_PDF_MUTATION = gql`
        mutation GeneratePdfStudentProfile(
          $student_id: String
          $name: String!
        ) {
          generatePdf(student_id: $student_id, name: $name) {
            error
            error_code
            message
            url
          }
        }
      `;

            let error_msg = "";
            let redirect_url = "";

            try {
                await this.$apollo
                    .mutate({
                        mutation: GENERATE_PDF_MUTATION,
                        variables: {
                            student_id: studentId,
                            name: "student-information",
                        },
                    })
                    .then((data) => {
                        if (data.data.generatePdf.error) {
                            error_msg = data.data.generatePdf.message;
                        } else {
                            redirect_url = data.data.generatePdf.url;
                        }
                    })
                    .catch((error) => {
                        error_msg = error;
                    });
            } catch (error) {
                error_msg = error.message || "Failed to authenticate, try later.";
            }

            if (error_msg) {
                this.$swal
                    .fire({
                        icon: "error",
                        title: "Oops...",
                        text: error_msg,
                    })
                    .then((result) => {
                        console.log(result);
                    });
            } else {
                const url = process.env.VUE_APP_PUBLIC_URL + redirect_url;
                window.open(url, "_blank");
            }

            this.isGenerateReport = false;
            document.body.classList.add("loading");
        },
        employmentRatePerEntity(entityName) {
            const total =
                this[`${entityName}Employed`] + this[`${entityName}UnEmployed`];
            if (total) {
                const percentage = (
                    (this[`${entityName}Employed`] / total) *
                    100
                ).toFixed(2);

                let color = "text-red-600";
                if (percentage >= 75) {
                    color = "text-green-600";
                } else if (percentage >= 50) {
                    color = "text-green-400";
                } else if (percentage >= 25) {
                    color = "text-yellow-600";
                }

                return `<div class="font-bold text-lg ${color}">${percentage}%</div>`;
            } else {
                return `<div class="font-bold text-lg text-red-600">0%</div>`;
            }
        },
        openSendJobOpporunityEmailModal() {
            if (this.selectedStudents) {
                this.showSendJobOpporunityEmailModal = true;
            } else {
                this.$swal
                    .fire({
                        icon: "error",
                        title: "Oops...",
                        text: 'No students selected. Please select at least one student to proceed.',
                    })
            }
        },
        closeSendJobOpporunityEmailModal() {
            this.showSendJobOpporunityEmailModal = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

body.loading {
    filter: blur(5px);
}

#loading-overlay {
    background-color: rgba(0, 0, 0, 0.25);
}

@responsive {
    .wd-380 {
        width: 380px;
    }

    .ht-242-7 {
        height: 242.7px;
    }

    .wd-216 {
        width: 216px;
    }

    .ht-216 {
        height: 216px;
    }

    .ht-350 {
        height: 350px;
    }

    .ht-430 {
        height: 430px;
    }

    .ht-60-vh {
        height: 60vh;
    }

    .ht-700 {
        height: 700px;
    }
}

.text-map-color {
    color: #09306b;
}

.vue-world-map {
    height: 60vh;
}

@media only screen and (max-width: 1023px) {
    .vue-world-map {
        height: 100%;
    }
}
</style>
